export default __webpack_public_path__ + "static/media/the-founder.4d6395dc.jpg";